import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function AuthPendingStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "auth-pending-heading", "aria-busy": "true", children: [_jsx("h3", { id: "auth-pending-heading", children: props.label }), _jsx("p", { role: "status", children: t('authentication.pending.status') })] }));
}
//# sourceMappingURL=pending-step.js.map